<template>
    <div
        class="transfers padded-page"
        :class="{
            none: amountIs0,
        }"
        ref="screenWrapper"
    >
        <div v-if="amountIs0" class="mb-5 text-white font-satoshi_r">
            <p class="text-lg">
                Shhh... We've got a secret. Sycamore transfers are the quickest way to send money, faster than a lightning flash ⚡️ <br /><br />
                Try it out and see for yourself.
            </p>
        </div>
        <div v-else-if="amountAbove1000" class="mb-5 text-white font-satoshi_r">
            <p class="text-lg">You sent a total of</p>
            <p class="text-4xl font-satoshi_b font-bold my-2">
                <CountUpNumber :endVal="reviewData?.total_outgoing_transfers ?? 0" currency="₦" />
            </p>
            <template v-if="!!reviewData?.top_recipient_name">
                <p class="mb-4">
                    <span class="font-satoshi_b capitalize">{{ reviewData?.top_recipient_name ?? "N/A" }}</span> was your best buddy.
                </p>
                <p>
                    You transferred to them <span class="font-satoshi_b">{{ reviewData?.count_of_transfers_from_top_recipient }} times</span>, a total
                    amount of <span class="font-satoshi_b">{{ $format.renderCurrency(reviewData?.top_recipient_amount) }}</span
                    >.
                </p></template
            >
        </div>
        <div v-else class="mb-5 text-white font-satoshi_r">
            <p class="text-lg">Your 2025 transfers were under</p>
            <p class="text-4xl font-satoshi_b font-bold my-2">
                <CountUpNumber :endVal="reviewData?.total_outgoing_transfers ?? 0" currency="₦" />
                <span>😔</span>
            </p>
            <p>
                We know you've got more to give! Let's see those transfer numbers skyrocket next time. <br /><br />
                Your friends and family will thank you (and so will we).
            </p>
        </div>
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        amountIs0() {
            return this.reviewData?.total_outgoing_transfers <= 0;
        },

        amountAbove1000() {
            return this.reviewData?.total_outgoing_transfers > 1000;
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.transfers {
    display: grid;
    color: white;
    background-color: #1141bf;
    min-height: 100vh;

    background-image: url("../../assets/images/year-in-review/transfer.svg");
    background-size: 80%;
    background-repeat: no-repeat;
    background-position: bottom center;
}

.transfers.none {
    background-image: url("../../assets/images/year-in-review/transfer-none.svg");
}
</style>
